import * as fieldModel from '../field';
import getFieldsByName from './get_fields_by_name';

/**
 * Retuns a comma seperated string containing all values for the form field
 */
export default function getFieldValuesByName(form, name) {
  const formFields = getFieldsByName(form, name);
  return [...formFields]
    .map(formField => fieldModel.processField(formField))
    .filter(formField => formField)
    .join();
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/form/get_field_values_by_name.js